import './styles/authCustom.scss';

//import './zone.js';
import './controllers/authCustomController.js';
export default 'zone';